import { render, staticRenderFns } from "./SlideDrawer.vue?vue&type=template&id=ff024724&scoped=true&"
import script from "./SlideDrawer.vue?vue&type=script&lang=js&"
export * from "./SlideDrawer.vue?vue&type=script&lang=js&"
import style0 from "./SlideDrawer.vue?vue&type=style&index=0&id=ff024724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff024724",
  null
  
)

export default component.exports